export default __webpack_public_path__ + "static/media/react.2f2532db.png";